<template>
  <div data-name="toggle-button">
    <div :id="'tth' + id" class="toggle-header">
      <span :style="
          dense
            ? 'display: block; font-size: 10px !important'
            : 'display: block'
        " class="toggle-label" v-if="title">{{ title }}</span>
      <STooltip v-if="tooltip" class="tooltip-col" :width="width" :tooltip="getTooltip()" />
    </div>
    <div :id="id" class="toggle" role="group">
      <button type="button" v-for="(opt, index) in options" :key="index" :class="[toggleClass(opt)]"
      :style="checkDisableStyle" @click="toggleButton(opt)" :disabled="disableFlag" :data-cy="`SToggle${index}_For_${CY}`">
        <!-- :class="[toggleClass(opt)]" -->
        {{ opt.label }}
        <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIMAAAAZCAYAAAASYJ1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAARzSURBVHgB7Zpvbts2GMYf2RowoAamof4+6QTzTjDlBHVPUOUEbU4Q7wRNT+D0BMlOEPcE8U4gZvu4bvWAGRgwxxqfiWxoWZRERS1sVD+AEENS5MuXT/hP9vB4QhlSFb+U4RTdkar6hQwRvjB+G43PN8A7ZNvJwBu8hiNb4CT6+/2iafkBeg6S9OsglIM5G2TZHF9tLz1gAUf4bhoEQePy6DlIhr4//z/ieeFw45/fbzZyxs1WLnXod5sW78VwgKRPniYZEOu/ZfwVfD/ceu5LMN9NR+O4SVkfPQdHtP7jEvn+a4909PTNAN5LOCD/46/kchFFq9WqplzPUeHfz5BlAm4EcrmY1xXqxXBk8L9763ltlotp+mT8qqpML4YjhMfFLbI3cGTg4ZynFFu+uWfgEYRr0VTFTbjWLNVzqtJiGe5QzUQGno9DNOdMhuuS9BtLPUKGt7CssQaJDC8sdSxVPbpvdPSFil8h7wfzF8j7HaKcsruQWLUbl+QJ5LbT74H6+0Tl0RZ9t/Bc2fgAl4t/h894YkBzAnVKOSnL1GJgZ2+wLwKTCdwIG9RZRmCpK4S9nRi5Q9nJVUm+HlBU1GGzITDaj+EGj3UzVLcbW/J0uzq+A5cLeUo4HeQ+bgxPKVwuovX7i2Kej/1BozMFdp06gfugvjbe0bNKE0RFXtG2AA+DzCcHvaj6OXaFULQlgJvQy/xTRoJdIQjs962NXz/C5aLV6SJfLq6jf1aimEdnZSpcVBg3M8oxfKfSQyPN3LHeqrQPaE9q1H0F+6xhlouNvKmRrq+2Yanjg1F2ZuTdGOm3aD54pk1JRbtXBRs1Ccr7tMfdaHwrQ+YYbov1DIyGBHi5YVf8DG5Xor+oJ51HR6cVgYbVqfvMYpvA7veQqRGPjfgp7LMO039CPc/RbIaL8SC8S9j3MwK5XU1nzVK2WYvbSTkr/Toa73zvoBhCPBhWxzs0h7OMOZ2HFWGiys8tdQlU22fmfWPEzf/iBapZ1uQLNPNRkTqfrfBIMUTr1XKbZU3EvEPxdpJiECreZN38Ec2hc39AvlvWu3Vb0M5I4L5RrcJ0clxTNsSnabfOZyE6aDta/3nx2I9ZFMPPKp0JVZ9Jz+G+mxbIB5iiiCrCmfFOl2K4NuKcdUJLuRh5/7rC3KQmyJffMup87sRjP2bxNMHp+YUyjEYn2J+2Arjvem33AmWYdddN1y4ssHs3wP2JKCkXons4beuB5pMO78Kv1WSyDc+tzvvM+5ZPikEgP45xVxuiOwNDuDuZlz1dioFw00dh6hknxOdBn8z0jNP9wBvwZnEwHN44XkLJzaf3Nlr/njCuL504ABQEZ4bvse8wKlpvhJ6V1CnU86+StKZwbzGz1CtQjyixgdB2LlMJqm8g2b+XxjuaO7TfPM6QnyT4pF+LYhCq3TK79H1GLV0IgXjoOQRa/7yvKyGQ/kPVEdOlEEgvhiOlayGQXgxHyKcQAunFcGS0FYJkWSUE0v8G8jDQ31bqL4yGCNr80gn+pvbI/h/vr5dHJ3nRbwAAAABJRU5ErkJggg=="
          @load="loaded" :alt="opt.disabled" style="display: none;">
      </button>
    </div>
    <input type="hidden" :value="value" />
  </div>
</template>

<script>
  import STooltip from "../components/STooltip.vue";
  import * as JSFunctions from "../Functions/Functions";

  export default {
    name: "SToggle",
    components: {
      STooltip,
    },
    watch: {
  dense: "setDisableFlag",
  disabled: "setDisableFlag",
},
    props: {
      CY: String,
      value: {
        type: null,
        required: true,
        default: 0,
      },
      options: {
        type: Array,
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      title: {},
      tabs: {
        type: Boolean,
        required: false,
      },
      background: {
        type: String,
      },
      tooltip: {
        type: String,
      },
      width: {
        type: String,
        default: "16px",
      },
      dense: {
        type: Boolean,
        required: false,
        default: true,
      },
    },
    data() {
      return {
        data: null,
        id: null,
        disableFlag: false,
      };
    },
    beforeMount() { },
    mounted() {
      let toggle = document.getElementById(this.id);
      let head = document.getElementById("tth" + this.id);
      head.style.width = toggle.offsetWidth + "px";
    },

    created() {
      this.id = "toggle#" + JSFunctions.uuid();
    },
    computed: {
      checkDisableStyle() {
    if (this.dense && this.disabled) {
      return {
        cursor: "not-allowed",
        padding: "4px 32px",
        opacity: 0.5,
        pointerEvents: "none",
      };
    } else if (this.dense) {
      return {
        padding: "4px 32px",
      };
    } else if (this.disabled) {
      return {
        cursor: "not-allowed",
        padding: "4px 32px",
        opacity: 0.5,
        pointerEvents: "none",
      };
    } else {
      return null;
    }
  },
      headerStyle() {
        return {
          width: "100px",
        };
      },
    },
    methods: {
      setDisableFlag() {
    if (this.dense && this.disabled) {
      this.disableFlag = true;
    } else {
      this.disableFlag = false;
    }
  },
      loaded(e) {
        if (e.target.alt) {
          e.target.parentElement.disabled = true
          e.target.parentElement.style.cursor = 'not-allowed'
        }
        else {
          e.target.parentElement.style.cursor = 'pointer'
        }
      },
      setValue(value) {
        var isChange = true;
        this.$emit("selected", {
          value: value,
          event: event,
          data: this.data,
        });
        // Change value.
        if (isChange == true) {
          this.$emit("input", value);
        }
      },
      toggleButton(opt) {
        if (this.value == opt.value) {
          return false;
        }
        this.data = opt.data;
        this.setValue(opt.value);
      },
      toggleSwitch(event) {
        this.setValue(!this.value);
      },
      toggleClass(opt) {
        if (opt.checked === undefined && this.tabs === false) {
          return this.value === opt.value ? "toggle-selected" : "toggle-simple";
        } else if (
          opt.checked === undefined &&
          this.tabs === true &&
          this.background
        ) {
          return this.value === opt.value
            ? "tabStyleWithBorder"
            : "tabStyleWithBorder-simple";
        } else if (opt.checked === undefined && this.tabs === true) {
          return this.value === opt.value ? "tabStyle" : "tabStyle-simple";
        } else if (this.tabs === true && this.background) {
          return this.value === opt.value
            ? "tabStyleWithBorder"
            : "tabStyleWithBorder-simple";
        } else if (this.tabs === true) {
          return this.value === opt.value ? "tabStyle" : "tabStyle-simple";
        } else {
          return this.value === opt.value ? "toggle-selected" : "toggle-simple";
        }
      },
      getTooltip() {
        return this.tooltip;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .toggle {
    background-color: white;
    display: inline-flex;
    flex-wrap: wrap;
    row-gap: 10px;
    border-radius: 16px;

    button {
      display: inline;
      font-family: "Roboto !important";
      font-size: 12px;
      line-height: 1.17;
      text-align: center !important;
      padding: 8px;
      // cursor: pointer;
    }
  }

  .toggle-simple {
    border-radius: 16px;
    border: solid 1px var(--white);
    background-color: var(--white);
  }

  .toggle-selected {
    border-radius: 16px;
    border: solid 1px var(--white);
    background-color: #434343 !important;
    color: #ffffff;
    font-weight: bold;
  }

  *:focus {
    outline: none;
  }

  .toggle-label {
    font-family: "Roboto !important";
    font-size: 13px;

    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: normal;
    color: #000000;
    padding-bottom: 8px;
  }

  .tabStyle {
    border-radius: 0px;
    border-bottom: 4px solid var(--primary) !important;
    background-color: #ffffff;
    color: #000000;
    border: none;
    // height: 45px;
    // width: 128px;
    font-weight: bolder !important;
    font-size: 12px !important;
  }

  .tabStyle-simple {
    border-radius: 0px;
    border-bottom: 2px solid var(--very-light-pink) !important;
    background-color: #ffffff;
    color: #000000;
    border: none;
    // height: 45px;
    // width: 128px;
    font-weight: 500 !important;
    font-size: 12px !important;
  }

  .tabStyleWithBorder {
    border-radius: 0px;
    border: 1px solid var(--very-light-pink);
    border-bottom: 4px solid var(--primary);
    background-color: #ffffff;
    color: #000000;
    // height: 45px;
    // min-width: 116px;
    font-weight: bold;
  }

  .tabStyleWithBorder-simple {
    border-radius: 0px;
    border: 1px solid var(--very-light-pink);
    background-color: var(--white);
    color: #000000;
    // height: 45px;
    // min-width: 116px;
  }

  .toggle-header {
    display: grid;
    grid-template-columns: 1fr auto;

    .tooltip-col {
      justify-self: end;
    }
  }

  @media screen and(min-width: 1024px) {
    .toggle {
      background-color: var(--white);
      display: inline-flex;
      flex-wrap: wrap;
      row-gap: 10px;

      button {
        display: inline;
        font-family: "Roboto !important";
        font-size: 12px;
        line-height: 1.17;
        text-align: center !important;
        padding: 8px;
        // cursor: pointer;
      }
    }
  }
</style>